import { Flag } from "./svg";
import { Container, Text } from "./styles";

interface BonusFlagProps {
	text: string;
}

export const BonusFlag: React.FC<BonusFlagProps> = ({
	text
}: BonusFlagProps) => {
	return (
		<Container data-tutorial-offer-ribbon>
			<Text>{text}</Text>
			<Flag largeString={text.length > 9} />
		</Container>
	);
};
